/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Export_DescInputs */



/**
* | output |
* | --- |
* | "Everything you can see, as a ZIP with one JSONL file. Rebuilt every 15 minutes. No deleted records or card data. Not a backup." |
*
* @param {Admin_Export_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const admin_export_desc = /** @type {((inputs?: Admin_Export_DescInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Export_DescInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Tout ce que vous pouvez voir, en ZIP contenant un fichier JSONL. Régénéré toutes les 15 minutes. Sans les données supprimées ni les cartes. Ce n'est pas une sauvegarde.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Todo lo que puede ver, en un ZIP con un archivo JSONL. Se regenera cada 15 minutos. Sin registros borrados ni datos de cartas. No es una copia de seguridad.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Tudo o que você pode ver, num ZIP com um arquivo JSONL. Regerado a cada 15 minutos. Sem registros excluídos nem dados de cartas. Não é um backup.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Tutto quello che puoi vedere, in uno ZIP con un file JSONL. Rigenerato ogni 15 minuti. Senza record eliminati né dati delle carte. Non è un backup.")
	return /** @type {LocalizedString} */ ("Everything you can see, as a ZIP with one JSONL file. Rebuilt every 15 minutes. No deleted records or card data. Not a backup.")
});